import './SegmentationWithActions.scss';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { MarkingToolIcon } from './MarkingToolIcon';
import { ObjectListActions } from './ObjectListActions';
import { IObjectListSegmentation } from './ObjectsList.container';

interface IMarkingToolItemProps {
  isReadOnly: boolean;
  objectListSegmentation: IObjectListSegmentation;
  onShowHideClick?: (segmentation: IObjectListSegmentation) => void;
  onDeleteClick?: (segmentation: IObjectListSegmentation) => void;
  onClick?: (segmentation: IObjectListSegmentation) => Promise<void>;
  showActions?: boolean;
  index?: number;
}

export const SegmentationWithActions = ({
  isReadOnly,
  objectListSegmentation,
  index,
  showActions = true,
  onShowHideClick,
  onDeleteClick: onDeleteSegmentationClick,
  onClick,
}: IMarkingToolItemProps): ReactElement => {
  const isVisible: boolean = objectListSegmentation.isVisible && objectListSegmentation.isMarkingToolTypeVisible;

  const handleShowHideClick = (): void => {
    if (onShowHideClick) {
      onShowHideClick(objectListSegmentation);
    }
  };
  const handleDeleteSegmentationClick = (): void => {
    if (onDeleteSegmentationClick) {
      onDeleteSegmentationClick(objectListSegmentation);
    }
  };

  const handleSegmentationClick = (): void => {
    if (onClick) {
      void onClick(objectListSegmentation);
    }
  };

  return (
    <div
      key={objectListSegmentation.id}
      className={`segmentation ${onClick !== undefined ? 'clickable' : ''}`}
      onClick={handleSegmentationClick}
    >
      <div
        className='icon-with-name'
        title={objectListSegmentation.name}
      >
        <div className='marking-tool-icon'>
          <MarkingToolIcon
            toolType={objectListSegmentation.feature.featureType}
            color={objectListSegmentation.feature.color}
          />
        </div>
        <div className={classNames('marking-tool-name', { active: objectListSegmentation.isSelected })}>{objectListSegmentation.name}</div>
        {index && <span className={classNames({ active: objectListSegmentation.isSelected })}>&nbsp; #{index}</span>}
      </div>
      {showActions && (
        <ObjectListActions
          isDeleteVisible={!isReadOnly}
          isVisible={isVisible}
          onDeleteClick={handleDeleteSegmentationClick}
          onShowHideClick={handleShowHideClick}
        />
      )}
    </div>
  );
};
